import React, { Component, useState, useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import { ReactDrawer } from '../parts';
import { useMount } from '../../hooks';
import { motion, AnimatePresence } from 'framer-motion';
import classnames from 'classnames';
import { slugify } from '../../utilities';

const MenuItem = ({ link, level, showImage, path }) => {
  const [isOpen, setIsOpen] = useState(false);
  const optionClasses = classnames('Nav__item', `level-${level}`, {
    'is-active': link.active,
  });
  const mobileNavExpandbleEvent = new Event('mobileNavExpandbleEvent');

  const handleClick = (e) => {
    if (link.links) {
      e.preventDefault();
      setIsOpen(!isOpen);
      if (!isOpen){
        e.currentTarget.setAttribute("aria-expanded", true)
      } else {
        e.currentTarget.setAttribute("aria-expanded", false)
      }
      document.body.dispatchEvent(mobileNavExpandbleEvent);
    }
  };

  return (
    <div className={optionClasses}>
      <motion.a initial={false} onClick={handleClick} href={link.url} className={`Nav__link level-${level} ${link.links ? "is-expandable" : ""}`}>
        <span>{link.title}</span>
      </motion.a>
      {link.links && (
        <AnimatePresence initial={true}>
          {isOpen && (
            <motion.div
              key="content"
              initial="open"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: 'auto' },
                collapsed: { opacity: 1, height: 'auto' },
              }}
              transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
            >
              <SubMenu items={link.links} parent={link} level={level} showImage={showImage} path={path}></SubMenu>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
};

const SubMenu = ({ items, level, parent, showImage, path }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`Nav__submenu level-${level}`} data-identifier={parent.object_handle}>
      {/* <a class="back_main" onClick={() => setIsOpen(!isOpen)}>Back to main Menu</a>
      <span class="parent_header">{parent.object_handle}</span> */}
      {items.map((link, index) => {
        return (
          <MenuItem link={link} level={level + 1} key={link.title} showImage={showImage} path={`${path}_${slugify(link.title)}`}></MenuItem>
        );
      })}
    </div>
  );
};

const MobileNav = ({ parentNode }) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [mainMenu, setMainMenu] = useState({ title: '', links: [] });
  const [secMenu, setSecMenu] = useState({ title: '', links: [] });
  const [customer, setCustomer] = useState();

  useMount(() => {
    let contentTag = parentNode.nextElementSibling;
    try {
      let menuData = JSON.parse(contentTag.innerText);
      // console.log(menuData);

      // main menu
      let menuKey = Object.keys(menuData[0])[0];
      setMainMenu(menuData[0][menuKey]);

      // sec menu
      let menuSecKey = Object.keys(menuData[1])[0];
      setSecMenu(menuData[1][menuSecKey]);

      // customer
      setCustomer(menuData[2]);
    } catch (error) {
      console.log(error);
    }
  });

  const { links } = mainMenu;
  const sec_links = secMenu.links;

  return (
    <>
      <button className="Button mobile-toggler" data-layout="noLayout" onClick={() => setShowDrawer(!showDrawer)} aria-label="close">
        <svg className="icon icon--primary" height="1em" viewBox="0 0 20 20" width="1em">
          <use xlinkHref="#menu"></use>
        </svg>
      </button>
      <ReactDrawer className="mobileNav" showDrawer={showDrawer} setShowDrawer={setShowDrawer} position={'left'}>
        <div className="Nav Nav--headerMobile">
          <svg className="icon icon--primary" height="1em" viewBox="0 0 20 20" width="1em" onClick={() => setShowDrawer(!showDrawer)}>
            <use xlinkHref="#close"></use>
          </svg>
          <form className="search" action="/search">
              <input type="text" className="search_input" placeholder="Search Contender" name="q" />
              <input type="submit" className="submit_search"/>
          </form>
        </div>
        <div className="Nav Nav--mainMobile Nav--vertical">
          {links.map((link, index) => {
            return <MenuItem link={link} level={1} key={link.title} path={link.object_handle}></MenuItem>;
          })}
        </div>
        <div className="Nav Nav--secMobile  Nav--vertical">
          {sec_links.map((link, index) => {
            return <MenuItem link={link} level={1} key={link.title} path={link.object_handle}></MenuItem>;
          })}
        </div>
      </ReactDrawer>
    </>
  );
};

export default component((node, ctx) => {
  const element = <MobileNav ctx={ctx} parentNode={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});